import { render, staticRenderFns } from "./HosCell.vue?vue&type=template&id=1043ae36&"
import script from "./HosCell.vue?vue&type=script&lang=js&"
export * from "./HosCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports